import map from "./map";

import compass from "./compass";
import controls from "./controls";

import marker from "./marker";
import markerPopup from "./marker-popup";
import markerTooltip from "./marker-tooltip";

import popup from "./popup";

import route from "./route";

export const BlazorTerra = {
    _internal: {
        map,
        controls: {
            ...controls,
            compass
        },
        marker,
        markerTooltip,
        markerPopup,
        popup,
        route
    }
};

(window as any).BlazorTerra = BlazorTerra;